import { render, staticRenderFns } from "./AmbitionAllBuildings.vue?vue&type=template&id=fc5fa418&scoped=true"
import script from "./AmbitionAllBuildings.vue?vue&type=script&lang=js"
export * from "./AmbitionAllBuildings.vue?vue&type=script&lang=js"
import style0 from "./AmbitionAllBuildings.vue?vue&type=style&index=0&id=fc5fa418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5fa418",
  null
  
)

export default component.exports